<div class="strategy-function-dialog admin-modal" [class.minimised]="minimise">
  <!-- Header -->
  <div class="modal-header">
    <h3 class="modal-title">
      Strategy Function@if (data.strategyName) {
 &mdash; {{ data.strategyName }}
}
    </h3>
    <div class="header-actions">
      <i class="fa"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         (click)="minimise = !minimise"
         [title]="minimise ? 'Expand' : 'Minimise'"></i>
      <i class="fa fa-times" (click)="cancel()" title="Close"></i>
    </div>
  </div>

  <!-- Body -->
  @if (!minimise) {
<div class="modal-body">
    <pre class="strategy-source"><code>{{ data.func || 'No function source available.' }}</code></pre>
  </div>
}

  <!-- Footer -->
  @if (!minimise) {
<div class="modal-footer">
    <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Close</button>
  </div>
}
</div>
